export const DeduplicationWholesaler = {
    path: '/deduplication/wholesaler',
    name: 'deduplication.wholesaler',
    component: () => import('@/views/Identical/DeduplicationWholesalerPage.vue'),
    children: [
        {
            path: '/deduplication/wholesaler/edit/:id',
            name: 'deduplication.wholesaler.edit',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {updateAction: true, type: 'wholesaler'},
        },
        {
            path: '/deduplication/wholesaler/delete/:id',
            name: 'deduplication.wholesaler.delete',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {deleteAction: true, type: 'wholesaler'},
        },
        {
            path: '/deduplication/wholesaler/view/:id',
            name: 'deduplication.wholesaler.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'wholesaler'},
        },
        {
            path: '/deduplication/wholesaler/visit/view/:id',
            name: 'deduplication.wholesaler.visit.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'wholesaler'},
        },
    ]
}